export default function BenefitsSection() {
  const benefits = [
    {
      label: 'ORGANIZADO',
      title: 'Produtos Organizados por Categorias',
      desc: 'Milhares de links divididos em 14 categorias. Encontre exatamente o que procura em segundos, sem perder tempo navegando em sites confusos.',
      image: 'https://readdy.ai/api/search-image?query=Color%20coded%20fashion%20product%20catalog%20displayed%20on%20large%20desktop%20monitor%20screen%20with%20organized%20spreadsheet%20grid%20layout%20on%20modern%20white%20desk%20setup%20natural%20daylight%20from%20window%20clean%20Scandinavian%20home%20office%20aesthetic%20soft%20sage%20green%20wall%20background%20minimal%20desk%20accessories%20warm%20wood%20desk%20surface%20professional%20yet%20cozy%20atmosphere%20high%20detail%20organized%20digital%20workspace%20productive%20mood&width=800&height=600&seq=benefit-organized-v2&orientation=landscape',
    },
    {
      label: 'ATUALIZADO',
      title: 'Links Atualizados Diariamente',
      desc: 'Nossa equipa verifica e atualiza todos os links todos os dias. Links quebrados são removidos e novos produtos são adicionados constantemente.',
      image: '',
      isDark: true,
    },
    {
      label: 'SEGURO',
      title: 'Compras Mais Seguras e Confiáveis',
      desc: 'Reduza o risco de fraudes com a nossa curadoria. Apenas vendedores com boa reputação e produtos verificados entram na nossa planilha.',
      image: 'https://readdy.ai/api/search-image?query=Young%20woman%20smiling%20while%20unboxing%20a%20beautifully%20wrapped%20fashion%20package%20at%20a%20bright%20kitchen%20counter%20morning%20sunlight%20streaming%20through%20window%20genuine%20excitement%20expression%20casual%20cozy%20home%20setting%20with%20ceramic%20mug%20and%20fresh%20flowers%20nearby%20lifestyle%20authentic%20moment%20warm%20natural%20tones%20cream%20walls%20wood%20countertops%20modern%20European%20apartment%20aesthetic%20candid%20joyful%20unboxing%20experience%20high%20detail%20packaging%20visible&width=800&height=600&seq=benefit-secure-v2&orientation=landscape',
    },
  ];

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
            <div>
              <h2 className="text-sm font-semibold text-foreground-400 uppercase tracking-wider mb-3">
                Benefícios
              </h2>
              <h3 className="text-3xl md:text-4xl font-bold text-foreground-950 italic" style={{ fontFamily: 'var(--font-heading)' }}>
                de Usar Nossa Planilha
              </h3>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-md">
              Mais de 20.000 utilizadores já confiam no CSSBuy Spreadsheet para encontrar produtos de qualidade, economizar tempo e comprar com segurança.
            </p>
          </div>

          {/* Cards grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {benefits.map((benefit) => (
              <div
                key={benefit.label}
                className={`group rounded-2xl overflow-hidden transition-all duration-300 cursor-default ${
                  benefit.isDark
                    ? 'bg-foreground-950'
                    : 'bg-background-100'
                }`}
              >
                {benefit.isDark ? (
                  <div className="h-56 flex items-center justify-center bg-foreground-900">
                    <div className="text-center">
                      <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-accent-500/15 flex items-center justify-center">
                        <i className="ri-shield-check-line text-3xl text-accent-500"></i>
                      </div>
                      <p className="text-accent-500 text-xs font-semibold">ATUALIZAÇÃO DIÁRIA</p>
                    </div>
                  </div>
                ) : (
                  <div className="h-56 overflow-hidden">
                    <img
                      src={benefit.image}
                      alt={benefit.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="p-6">
                  <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mb-3 ${
                    benefit.isDark
                      ? 'bg-accent-500/20 text-accent-500'
                      : 'bg-accent-100 text-accent-800'
                  }`}>
                    {benefit.label}
                  </span>
                  <h4 className={`text-lg font-bold mb-2 ${
                    benefit.isDark ? 'text-white' : 'text-foreground-950'
                  }`}>
                    {benefit.title}
                  </h4>
                  <p className={`text-sm leading-relaxed ${
                    benefit.isDark ? 'text-foreground-300' : 'text-foreground-600'
                  }`}>
                    {benefit.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}